import { TIME_SLOT_TYPE } from "constants/order";
import { useForwardOrderMultiple, useTimeSlots } from "hooks";
import { checkErrorForHandleOrdersCoordinate } from "pages/Orders/utils";
import React, { useEffect, useMemo, useState } from "react";
import { useToasts } from "react-toast-notifications";
import OrderCoordinationForm from "pages/Orders/OrderDetail/OrderCoordination/OrderCoordinationForm/OrderCoordinationForm";
import CoordinateCollectorOrder from "pages/BloodCollectionOrder/DetailPage/OrderDetailFunction/CoordinateCollectorOrder";
import { Modal } from "reactstrap";

const initcollectorByRuleParams = {
  action_date: "",
  time_slot: 0,
  province_code: "",
  district_code: "",
  ward_code: "",
};

const useCoordinateOrder = ({ onSuccesCoordinate }) => {
  const { addToast } = useToasts();
  const [isOpenModalCoordinate, setIsOpenModalCoordinate] = useState(false);
  const [orderId, setOrderId] = useState(undefined);
  const [orderDetail, setOrderDetail] = useState(null);
  const [defaultData, setDefaultData] = useState(null);
  const [isAddressLevel2, setIsAddressLevel2] = useState(false);
  const [isCollector, setIsCollector] = useState(false);

  const [hubId, setHubId] = useState(null);
  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: {
      "filter[type][in]": [TIME_SLOT_TYPE.COORDINATE, TIME_SLOT_TYPE.COLLECTOR],
      "filter[hub_id]": undefined,
    },
    run: false,
    enabled: false,
    key: "time-slot-orders",
  });
  const [collectorByRuleParams, setcollectorByRuleParams] = useState(
    initcollectorByRuleParams
  );

  const { mutate: onForwardOrder } =
    useForwardOrderMultiple(onSuccesCoordinate);

  const { data: timeSlots, refetch: refetchTimeSlots } =
    useTimeSlots(timeSlotsParams);

  useEffect(() => {
    if (timeSlotsParams && timeSlotsParams?.run) {
      refetchTimeSlots();
    }
  }, [timeSlotsParams]);

  const handleCoordinate = row => {
    setOrderId(row?.id);
    setOrderDetail(row);
    let {
      messError,
      hub_id,
      isCollector: isCollectorOrder,
    } = checkErrorForHandleOrdersCoordinate({
      selectedRows: [row],
    });

    if (messError) {
      addToast(messError, {
        appearance: "warning",
        autoDismiss: true,
      });
    } else {
      setIsCollector(isCollectorOrder);
      setHubId(hub_id);
      setTimeSlotsParams(prev => {
        return {
          ...prev,
          params: {
            ...prev.params,
            "filter[hub_id]": hub_id,
          },
          run: true,
        };
      });

      const isAddressLevel2 = row?.sender_ward_code == null;
      setIsAddressLevel2(isAddressLevel2);

      setDefaultData({
        timeslot_id: row?.timeSlot?.id,
        runner_id: row?.orderDelivery?.runner_id,
        full_address: row?.sender_address,
        ward_code: isAddressLevel2 ? null : row?.sender_ward_code,
        district_code: row?.sender_district_code,
        province_code: row?.sender_province_code,
        contact_name: row?.sender_contact_name,
        contact_phone: row?.sender_contact_phone,
        note: `${row?.mainNote || row?.note || ""}`,
        is_new_address: isAddressLevel2 ? "N" : "O",
      });

      toggleModalCoordinate();
    }
  };

  const toggleModalCoordinate = () => {
    setIsOpenModalCoordinate(prev => !prev);
    if (isOpenModalCoordinate) {
      setDefaultData(null);
      setOrderDetail(null);
      setIsAddressLevel2(false);
    }
  };

  const onTimeSlotChange = timeslot_id => {
    const params = { ...collectorByRuleParams };
    params.time_slot = timeslot_id;
    setcollectorByRuleParams(params);
  };

  const onActionDateChange = action_date => {
    const params = { ...collectorByRuleParams };
    params.action_date = action_date;
    setcollectorByRuleParams(params);
  };

  const handleForwardOrder = data => {
    const forwardOrderParams = { ...data };
    forwardOrderParams.ids = [orderId];
    onForwardOrder(forwardOrderParams);
  };

  const OrderCoordinateModal = useMemo(() => {
    return (
      <Modal
        isOpen={isOpenModalCoordinate}
        centered
        toggle={toggleModalCoordinate}
        scrollable
        size="xl"
      >
        {isOpenModalCoordinate && isCollector ? (
          <CoordinateCollectorOrder
            orderIds={[orderId]}
            hubId={hubId}
            orderDetail={orderDetail}
            isOpenCoordinateModal={true}
            setIsOpenCoordinateModal={setIsOpenModalCoordinate}
            refetchSuccess={onSuccesCoordinate}
            clearSelect={() => {}}
            isAddressLevel2={isAddressLevel2}
          />
        ) : (
          isOpenModalCoordinate && (
            <OrderCoordinationForm
              defaultData={defaultData}
              timeSlots={timeSlots?.items}
              hubId={hubId}
              isAddressLevel2={isAddressLevel2}
              handleCancel={toggleModalCoordinate}
              onTimeSlotChange={onTimeSlotChange}
              onActionDateChange={onActionDateChange}
              onForwardOrder={handleForwardOrder}
            />
          )
        )}
      </Modal>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isOpenModalCoordinate,
    hubId,
    timeSlots,
    defaultData,
    isAddressLevel2,
    orderId,
    isCollector,
    orderDetail,
  ]);
  return {
    handleCoordinate,
    OrderCoordinateModal,
  };
};

export default useCoordinateOrder;
